import axios from 'axios';
import {useQuery, useQueryClient} from 'react-query';
import {environment} from '../config/environment';

export const useLatestMempoolTxs = () => {
    const queryClient = useQueryClient();
    return useQuery(
        'latest-mempool-txs',
        () => axios.get(`${environment.apiBase}/mempool?count=10`).then((res) => res.data),
        {
            retry: false,
            staleTime: 1000 * 30,
            cacheTime: 1000 * 30,
            refetchInterval: 1000 * 30,
            onSuccess: (data) => {
                if (data && data.payload) {
                    // Update tx
                    Object.keys(data.payload).forEach((i) => {
                        const r = {type: 'tx', payload: data.payload[i]};
                        queryClient.setQueryData(['mempool-tx', data.payload[i].height], r);
                        queryClient.setQueryData(['mempool-tx', '0x' + data.payload[i].hash], r);
                    });
                }
            },
        }
    );
};

export default useLatestMempoolTxs;
